import { gql } from "@apollo/client";

export const CREATE_PROGRAMMING_STRUCTURE = gql`
  mutation createProgrammingStructure(
    $scenarioId: ID!
    $originId: ID
    $input: ProgrammingStructureCrudInput!
  ) {
    cube(scenarioId: $scenarioId, originId: $originId) {
      programmingStructuresCrud(input: $input) {
        userCanSkipValidations
        skippedValidations
        commited
        payload {
          creates {
            skippedValidations
            commited
            structure {
              id
              code
              name
            }
            validationErrors {
              __typename
              ... on ProgrammingStructureValidation {
                id
                code
                reason
              }
              ... on ProgrammingStructureDuplicateCodeSubject {
                id
                code
                subjectCodes
                reason
              }
              ... on ProgrammingStructureDependencyCodeNotInStructure {
                id
                programmingStructurePartCode
                dependencyCode
                reason
              }
              ... on ProgrammingStructureStageNotFound {
                programmingStructureStageId
                programmingStructurePartCode
                reason
              }
            }
          }
        }
      }
    }
  }
`;
